<template>
	<div
		class="rounded-full"
		:style="{
			backgroundColor: color,
			width: `${radius * 2}px`,
			height: `${radius * 2}px`,
		}"
	/>
</template>

<script setup lang="ts">
	interface Props {
		color: string;
		radius?: number;
	}

	withDefaults(defineProps<Props>(), {
		radius: 6,
	});
</script>
